import React from 'react';
import { Box, Field, FieldTypes, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

const FIELD_WIDTH = '218px';

type LockboxField = Field & {
  node?: React.ReactNode;
}

interface FieldWrapperProps {
  isSmall?: boolean;
}

export const LockboxFieldWrapper = styled(Box)<FieldWrapperProps>`
  &:not(:last-child) {
    margin-bottom: ${({ theme, isSmall }) => isSmall ? theme.spacings.spacing8 : theme.spacings.spacing12};
  }
`;

interface FieldProps {
  field: LockboxField;
  isEditMode?: boolean;
}

const TextField: React.FC<FieldProps> = ({ field }) => (
  <Inscription
    data-testid={`${field?.name}_field-value`}
    weight={700}
    color="textBody"
    lineHeight="20px"
    margin={{ left: 'spacing8' }}
    style={{ whiteSpace: 'pre' }}
  >
    {field?.value}
  </Inscription>
);

const NodeField: React.FC<FieldProps> = ({ field, isEditMode }) => {
  if (isEditMode) {
    return field?.node;
  }

  return <TextField field={field} />;
};

interface Props {
  testId?: string;
  fields: LockboxField[];
  isEditMode?: boolean;
  isSmall?: boolean;
}

const LockboxForm: React.FC<Props> = ({ testId, fields, isEditMode, isSmall }) => (
  <Box data-testid={`${testId}_form`}>
    {fields?.map((field) => (
      <LockboxFieldWrapper key={field?.name} isSmall={isSmall} direction="row" align="center">
        <Box width={{ min: FIELD_WIDTH, max: FIELD_WIDTH }} style={field?.fieldWrapperStyles}>
          <Inscription
            data-testid={`${field?.name}_field-title`}
            color="textSecondary"
            lineHeight="20px"
          >
            {field?.label}
          </Inscription>
        </Box>
        {field.type === FieldTypes.Text && <TextField field={field} isEditMode={isEditMode} />}
        {field.type === FieldTypes.Node && <NodeField field={field} isEditMode={isEditMode} />}
      </LockboxFieldWrapper>
    ))}
  </Box>
);

export default LockboxForm;
